<template>
<div class="main my">
  <!-- 产品管理 -->
  <div class="model-box bcg crw mbn tac">
    <h4 @click="goTo('/setproductadd')">+ 添加产品</h4>
  </div>
  <div class="bcw">
    <!-- 列表 -->
    <van-swipe-cell :right-width="65" v-for="(item,index) in list" :key="index" class="bcw clear">
      <van-cell-group>
        <van-cell class="cell-item" :center="true" :value="'￥'+item.price" value-class="red fs3" :to="'/setproductadd?id='+item.id">
          <template slot="title">
            <h2 class="fs3 mtn">{{item.title}}</h2>
            <div class="c9 fs2" style="margin-top:2px;">
              <span v-if="item.useNum">{{item.useNum}}次，</span>
              <span v-if="item.timeSpan">有效期{{item.timeSpan}}天</span>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
      <span class="right_del" slot="right" @click="handleDel(index,item.id)">删除</span>
    </van-swipe-cell>

    <div v-if="list.length==0" v-show="none" class="tac c9 fs2 ptm pbm">~ 暂无记录 ~</div>
    <!-- //列表 -->
  </div>
</div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import wx from "weixin-js-sdk";
import weChat from "@/assets/scripts/wechat";

import moment from 'moment';
moment.locale('zh-cn');
import {
  Cell, CellGroup,Checkbox, CheckboxGroup,SwitchCell, Toast,SwipeCell
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Checkbox).use(CheckboxGroup).use(SwitchCell).use(Toast).use(SwipeCell);



export default {
  components: {
  },
  data() {
    return {
      list:[],
      none:false,
      value:'',
      role: this.$route.query.role  //判断角色是否为coach
    }
  },
  created(){
    // 获取私教课列表
    this.fetchData()
  },
  methods: {
    goTo(url){
      this.$router.push(url)
    },
    fetchData(keywords,more) {
      // 获取列表
      this.$http.post('product_manage/getCardList').then(res => {
        if (!res.data.code) {
          this.list = res.data.value;
        } else {
          Toast.fail(res.data.message);
        }

        this.none = true //解决“暂无记录”默认显示的问题
      })
    },
    handleDel(index,id){
      // 删除
      let _this = this
      this.$http.post('product_manage/deleteCard',{
          id: id
      }).then(function(res){
          if(res.data.code == 0){
            _this.list.splice(index,1)
            _this.fetchData()
          }else{
            Toast(res.data.message)
          }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.my-model{
  padding: .1rem 0; 
}
.cell-item{
  height: .75rem;
}
// 左滑删除按钮
.right_del{
  height:.66rem;
  margin-top:.05rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/manage/SetProductList.vue